import * as React from 'react';
import styled, { css } from 'styled-components';
import PageLayout from '../PageLayout';
import { PageTitle } from '../styled-components';
import { cssClampValue } from '../../utils/common';
import illustrationSrc from './images/illustration.svg';
import wavesSrc from './images/waves.svg';

const Container = styled.div<{ $headerHidden: boolean; $justifyContent?: 'flex-start' | 'center' }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: ${({ $headerHidden }) => ($headerHidden ? 'flex-start' : 'center')};
  padding-top: ${({ $headerHidden }) => ($headerHidden ? cssClampValue(40, 80) : '0')};

  // If justifyContent is set, override the default value
  ${({ $justifyContent }) =>
    $justifyContent
      ? css`
          justify-content: ${$justifyContent};
        `
      : ''}
`;

const Title = styled(PageTitle)`
  margin: 0 0 20px;
  text-align: center;
  font-size: ${cssClampValue(48, 64)};
`;

const Description = styled.p`
  max-width: 600px;
  margin: 0 auto;
  text-align: center;
`;

const Content = styled.div`
  position: relative;
  margin-top: 40px;
  text-align: center;
  z-index: 2;
`;

const WavesWrapper = styled.div`
  overflow: hidden;

  img {
    width: 100%;
    max-width: 100%;
    min-width: 800px;
    height: auto;
    margin-bottom: -10px;
  }
`;

const IllustrationContainer = styled.div`
  position: relative;
`;

const IllustrationWrapper = styled.div`
  position: absolute;
  bottom: 34px;
  right: 20px;
  z-index: 1;

  img {
    width: 110px;
    height: auto;
  }

  @media (min-width: 768px) {
    right: 0;
  }

  @media (min-width: 768px) and (min-height: 600px) {
    img {
      width: 200px;
    }
  }

  @media (min-width: 992px) and (min-height: 800px) {
    img {
      width: 250px;
    }
  }

  @media (min-width: 1200px) and (min-height: 900px) {
    img {
      width: 350px;
    }
  }
`;

interface Props {
  title: React.ReactNode;
  description?: React.ReactNode;
  hideHeader?: boolean;
  children: React.ReactNode;
  justifyContent?: 'flex-start' | 'center';
}

export default function SignInPageLayout({
  title,
  description = null,
  hideHeader = false,
  justifyContent = undefined,
  children,
}: Props) {
  return (
    <PageLayout hideFooter hideHeader={hideHeader} hideSearch>
      <Container className="container" $headerHidden={hideHeader} $justifyContent={justifyContent}>
        {title && <Title>{title}</Title>}
        {description && <Description>{description}</Description>}
        <Content>{children}</Content>
      </Container>

      <WavesWrapper>
        <img src={wavesSrc} alt="" />
      </WavesWrapper>

      <IllustrationContainer className="container">
        <IllustrationWrapper>
          <img src={illustrationSrc} alt="" />
        </IllustrationWrapper>
      </IllustrationContainer>
    </PageLayout>
  );
}
